(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-installments"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('.product-installments').forEach(function (el) {
      var form = el.closest('form') || document.querySelector('form[action="/cart/add"]');
      if (!form) return;

      function update() {
        var priceEl = document.querySelector('[data-product-price],.price__regular .price-item');
        var rawPrice = el.dataset.productPrice;

        var select = form.querySelector('select[name="id"]');
        if (select) {
          var opt = select.options[select.selectedIndex];
          if (opt && opt.dataset.variantPrice) rawPrice = opt.dataset.variantPrice;
        }

        var installments = parseInt(el.dataset.installments, 10);
        if (!rawPrice || !installments) return;

        var value = Math.ceil(parseInt(rawPrice, 10) / installments);
        var formatted = (value / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

        var valueEl = el.querySelector('.product-installments__value');
        if (valueEl) valueEl.textContent = formatted;
      }

      document.addEventListener('variant:change', update);
      document.addEventListener('variantChange', update);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-notify"] && !Shopify.designMode) return;
  try {
    (function () {
    function initNotify() {
      document.querySelectorAll('.product-notify').forEach(function (el) {
        var productTitle = el.dataset.productTitle || '';
        var form      = el.querySelector('.product-notify__form');
        var emailInput = el.querySelector('.product-notify__input');
        var notifyBtn = el.querySelector('.product-notify__btn');
        var success   = el.querySelector('.product-notify__success');
        var errorEl   = el.querySelector('.product-notify__error');

        // ---------- Referência ao botão de compra ----------
        var addToCartBtn = document.querySelector('.add-to-cart-button');
        var variantInput = document.querySelector('input[name="id"]');

        function setVisible(show) {
          el.style.display = show ? '' : 'none';
          if (!show) {
            form.style.display = '';
            success.hidden = true;
            errorEl.hidden = true;
            emailInput.value = '';
          }
        }

        function syncWithCartBtn() {
          if (!addToCartBtn) return;
          // Botão desabilitado = esgotado
          setVisible(addToCartBtn.disabled === true || addToCartBtn.hasAttribute('disabled'));
        }

        // Estado inicial
        syncWithCartBtn();

        // Observa mudanças no atributo "disabled" do botão de compra
        if (addToCartBtn) {
          new MutationObserver(syncWithCartBtn).observe(addToCartBtn, { attributes: true, attributeFilter: ['disabled'] });
        }

        // Também escuta o evento nativo do tema como reforço
        document.addEventListener('variant:update', function (e) {
          var resource = e.detail && e.detail.resource;
          if (resource) setVisible(resource.available === false);
        });

        // ---------- Submissão ----------
        form.addEventListener('submit', function (e) {
          e.preventDefault();

          var email = emailInput.value.trim();
          if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            errorEl.textContent = 'Digite um e-mail válido.';
            errorEl.hidden = false;
            return;
          }

          errorEl.hidden = true;
          notifyBtn.disabled = true;
          var originalLabel = notifyBtn.textContent;
          notifyBtn.textContent = '...';

          var vid = variantInput ? variantInput.value : '';
          var subject = 'Avise-me quando chegar: ' + productTitle + (vid ? ' (ID ' + vid + ')' : '');

          var bodyText = 'E-mail: ' + email + '\n'
            + 'Produto: ' + productTitle + '\n'
            + 'Variant ID: ' + vid + '\n'
            + 'URL: ' + window.location.href;

          var params = new URLSearchParams();
          params.append('form_type', 'contact');
          params.append('utf8', '✓');
          params.append('contact[name]', 'Avise-me quando chegar');
          params.append('contact[email]', email);
          params.append('contact[subject]', subject);
          params.append('contact[body]', bodyText);

          fetch('/contact', { method: 'POST', body: params })
            .then(function (r) {
              if (r.ok || r.redirected) {
                form.style.display = 'none';
                success.hidden = false;
              } else { throw new Error(r.status); }
            })
            .catch(function () {
              notifyBtn.disabled = false;
              notifyBtn.textContent = originalLabel;
              errorEl.textContent = 'Erro ao enviar. Tente novamente.';
              errorEl.hidden = false;
            });
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initNotify);
    } else {
      initNotify();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
